export default "__VITE_ASSET__BqU_ekmM__"